import { useIonModal } from '@ionic/react'
import moment from 'moment'

import { QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST } from '@apps-common/apis/portal/dash/get-dash-recent-pending-cancel-list'
import { useScheduleUnitCancellation } from '@apps-common/apis/portal/unit/schedule-unit-cancellation'
import { useUnscheduleUnitCancellation } from '@apps-common/apis/portal/unit/unschedule-unit-cancellation'
import { ScheduleCancellationModal } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { ConfirmModal, ConfirmModalAction } from '@apps-common/components/modals/ConfirmModal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'
import { UNIT_STATUS_ACTIVE } from '@apps-common/config/unit-filter'
import { queryClient } from '@apps-common/lib'
import { defaultModalAnimations } from '@apps-common/lib/modal-animations'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

interface IProps {
  loading?: boolean
  unit?: IUnitGenericDetailsModel
  refetchCallback: () => void
}

export const ScheduleCancellationButton: React.FC<IProps> = ({ loading, unit, refetchCallback }) => {
  const { mutate: scheduleCancellation, isPending: isPendingScheduleCancellation } = useScheduleUnitCancellation(true, (data) => {
    if (data) {
      refetchCallback()
      console.log('Refetching queries')
      queryClient.refetchQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST() })
    }
  })
  const { mutate: unScheduleCancellation, isPending: isPendingUnScheduleCancellation } = useUnscheduleUnitCancellation(true, (data) => {
    if (data) {
      refetchCallback()
      console.log('Refetching queries')
      queryClient.refetchQueries({ queryKey: QUERY_KEY_GET_DASH_RECENT_PENDING_CANCEL_LIST() })
    }
  })

  const [presentScheduleCancellationModal, dismissScheduleCancellationModal] = useIonModal(ScheduleCancellationModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      if (role === ModalDismiss.Confirm && unit && data) {
        scheduleCancellation({ unitId: unit.unitId, cancelDate: data })
      }
      dismissScheduleCancellationModal()
    }
  })

  const [presentConfirmModal, dismissConfirmModal] = useIonModal(ConfirmModal, {
    componentProps: {
      text: 'Un-schedule cancellation',
      description: `Confirm you would like to remove this devices' cancellation scheduled by ${unit?.cancelUserName} for ${moment(unit?.cancelDate).format('ddd Do MMM YY')}.`,
      action: ConfirmModalAction.Success
    },
    onDismiss: (data: any, role: string) => {
      if (role === ModalDismiss.Confirm && unit) {
        unScheduleCancellation({ unitId: unit?.unitId || '' })
      }
      dismissConfirmModal()
    }
  })

  const isLoading = loading || !unit
  const updating = isPendingScheduleCancellation || isPendingUnScheduleCancellation

  const isActiveStatus = unit?.status === UNIT_STATUS_ACTIVE.value
  const hasCancellationScheduled = unit?.cancelDate

  return (
    <ButtonRoundLg
      type='button'
      loading={isLoading || updating || !isActiveStatus}
      className={hasCancellationScheduled ? 'action-success' : 'action-warning'}
      callback={() => {
        if (hasCancellationScheduled) {
          presentConfirmModal({ ...defaultModalAnimations })
        } else {
          presentScheduleCancellationModal({ ...defaultModalAnimations })
        }
      }}
      tooltip={{
        id: 'unit-schedule-cancel',
        message: hasCancellationScheduled ? 'Un-schedule cancellation' : 'Schedule cancellation',
        place: 'bottom'
      }}
    >
      {hasCancellationScheduled && <commonIcons.cancelRestore className='text-[1.2rem]' />}
      {!hasCancellationScheduled && <commonIcons.cancel className='text-[1rem]' />}
    </ButtonRoundLg>
  )
}
